<template>
    <div style="margin: 30px;width: calc(100% - 60px)">
        <el-button type="primary" :disabled="loading" @click="open">折扣</el-button>
        <downloadable-table :data="data" :loading="loading" title="历史数据" show-summary :summary-method="summaryMethod">
            <template #header>
                <div style="margin-bottom: 5px">
                    <el-select v-model="query.product" multiple clearable :disabled="loading" style="width: 500px"
                               filterable placeholder="全部产品">
                        <el-option v-for="p in $root.product_list" :key="p.id" :value="p.id"
                                   :label="p.nickname">{{ p.nickname }} ({{ p.platform }})
                        </el-option>
                    </el-select>
                    <date-range-picker v-model="query" :disabled="loading"></date-range-picker>
                    <el-select v-model="query.country" filterable :disabled="loading"
                               style="margin-left: 5px;width: 200px">
                        <el-option label="全部国家" value="GLOBAL"></el-option>
                        <el-option v-for="c in $root.country_list" :key="c.code" :value="c.code"
                                   :label="`${c.en_name}(${c.code})`"></el-option>
                    </el-select>
                    <el-button type="primary" :loading="loading" @click="init"
                               style="margin-left: 5px">查询
                    </el-button>
                </div>
            </template>
            <el-table-column width="120" prop="date" label="日期" sortable></el-table-column>
            <el-table-column width="100" prop="bq_installs" label="首次打开"></el-table-column>
            <el-table-column width="100" prop="ua_installs" label="非自然量"></el-table-column>
            <el-table-column width="100" prop="bq_dau" label="日活"></el-table-column>
            <el-table-column width="100" label="总收入" prop="revenue">
                <template #default="scope">
                    {{
                        scope.row.iaa_revenue + scope.row.iap_proceed ? (scope.row.iaa_revenue + scope.row.iap_proceed).toFixed(2) : null
                    }}
                </template>
            </el-table-column>
            <el-table-column width="100" label="总花费" prop="spend">
                <template #default="scope">
                    {{ scope.row.ua_spend }}
                </template>
            </el-table-column>
            <el-table-column width="100" label="利润" prop="profit">
                <template #default="scope">
                    {{
                        scope.row.iaa_revenue + scope.row.iap_proceed - scope.row.ua_spend ? (scope.row.iaa_revenue + scope.row.iap_proceed - scope.row.ua_spend).toFixed(2) : null
                    }}
                </template>
            </el-table-column>
            <el-table-column width="100" label="ARPDAU" prop="arpdau">
                <template #default="scope">
                    {{
                        (scope.row.iaa_revenue + scope.row.iap_proceed) / scope.row.bq_dau ? ((scope.row.iaa_revenue + scope.row.iap_proceed) / scope.row.bq_dau).toFixed(4) : null
                    }}
                </template>
            </el-table-column>
        </downloadable-table>
    </div>
    <el-dialog v-model="opened" width="80%">
        <template v-for="p in products">
            <h1>{{ p.nickname }} ({{ p.platform }})</h1>
            <p>
                当前折扣：{{ p.ratio }}
                <el-button type="primary" size="small" @click="openDialog(p)" :disabled="loading"
                           style="margin-left: 10px">修改折扣
                </el-button>
            </p>
            <el-table :data="p.history">
                <el-table-column label="折扣" prop="ratio" width="100"></el-table-column>
                <el-table-column label="生效日期" prop="start" width="200"></el-table-column>
                <el-table-column label="截止日期" prop="end" width="200"></el-table-column>
            </el-table>
        </template>
        <template #footer>
            <el-button @click="opened = false" type="primary" :disabled="loading">关闭</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="dialog_opened">
        <el-form :model="form" label-width="80px" ref="form">
            <p style="color: var(--el-color-danger)">新折扣将在 {{ timestampToDate(Date.now() + 24 * 3600 * 1000) }} 生效</p>
            <el-form-item label="折扣">
                <el-slider v-model="form.ratio" :max="1" :min="0" :step="0.01" show-input></el-slider>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button text :loading="loading" @click="dialog_opened = false" type="primary">取消</el-button>
            <el-button :loading="loading" @click="submit" type="primary">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import DownloadableTable from "../../base/DownloadableTable";
import DateRangePicker from "../../base/DateRangePicker";
import axios from 'ts-axios-new';
import {timestampToDate} from "../../libs/utils";

export default {
    name: "CY",
    components: {DownloadableTable, DateRangePicker},
    data() {
        const now = Date.now();
        return {
            data: [],
            loading: false,
            ad_channel: [],
            cash_channel: [],
            opened: false,
            products: [],
            dialog_opened: false,
            query: {
                start: timestampToDate(now - 32 * 24 * 3600 * 1000) > '2021-09-01' ? timestampToDate(now - 32 * 24 * 3600 * 1000) : '2021-09-01',
                end: timestampToDate(now - this.$root.t * 24 * 3600 * 1000),
                country: 'GLOBAL',
                product: [],
            },
            form: {
                product_id: '',
                ratio: 1,
            },
        }
    },
    methods: {
        timestampToDate(timestamp) {
            return timestampToDate(timestamp);
        },
        openDialog(p) {
            this.dialog_opened = true;
            this.form.product_id = p.id;
        },
        open() {
            this.opened = this.loading = true;
            const product = [];
            this.products.forEach(p => {
                product.push(p.id);
                p.ratio = 1;
                p.history = [];
            });
            axios.get('/api/v1/supervisor/sales', {params: {product}}).then(res => {
                res.data.data.salesList.forEach(s => {
                    this.products.forEach(p => {
                        if (p.id === s.product_id) {
                            p.history.push(s);
                            if (!s.end) {
                                p.ratio = s.ratio;
                            }
                        }
                    });
                });
                this.products.forEach(p => {
                    p.history.sort((a, b) => {
                        return b.c_time - a.c_time;
                    });
                });
                this.loading = false;
            });
        },
        init() {
            this.loading = true;
            this.ad_channel = [];
            this.cash_channel = [];
            axios.get('/api/v1/supervisor/report', {params: this.query}).then(res => {
                this.data = res.data.data.metricList;
                this.ad_channel = res.data.data.ad_channel;
                this.cash_channel = res.data.data.cash_channel;
                this.loading = false;
            })
        },
        summaryMethod({columns, data}) {
            const summary = [];
            columns.forEach((c, i) => {
                if (['bq_dau', 'iaa_revenue'].includes(c.property) || c.property.includes('_revenue') || c.property.includes('_spend') || c.property.includes('iap') || c.property.includes('install')) {
                    summary[i] = 0;
                    let counter = 0;
                    data.forEach(d => {
                        if (d[c.property]) {
                            summary[i] += d[c.property];
                            counter += 1;
                        }
                    });
                    if (c.property === 'bq_dau') {
                        summary[i] = parseInt(summary[i] / counter + '');
                    } else if (c.property.includes('install')) {
                        summary[i] = parseInt(summary[i]);
                    } else {
                        summary[i] = summary[i].toFixed(2);
                    }
                } else if (c.property === 'revenue') {
                    summary[i] = 0;
                    data.forEach(d => {
                        summary[i] += d.iaa_revenue + d.iap_proceed;
                    });
                    summary[i] = summary[i].toFixed(2);
                } else if (c.property === 'spend') {
                    summary[i] = 0;
                    data.forEach(d => {
                        summary[i] += d.ua_spend;
                    });
                    summary[i] = summary[i].toFixed(2);
                } else if (c.property === 'profit') {
                    summary[i] = 0;
                    data.forEach(d => {
                        summary[i] += d.iaa_revenue + d.iap_proceed - d.ua_spend;
                    });
                    summary[i] = summary[i].toFixed(2);
                }
            });
            return summary;
        },
        submit() {
            this.loading = true;
            axios.post('/api/v1/supervisor/sales', this.form).then(res => {
                this.dialog_opened = false;
                this.open();
            });
        },
    },
    mounted() {
        this.$root.product_list.forEach(p => {
            if (p.organization === 'cy') {
                this.products.push(p);
                this.query.product.push(p.id);
            }
        });
        this.init();
    },
}
</script>

<style scoped>

</style>